// src/components/PdfViewer.js
import React from "react";

const PdfViewer = ({ pdfUrl }) => {
    if (!pdfUrl) return <p>No PDF available</p>;

    return (
        <div>
            <object
                data={pdfUrl}
                type="application/pdf"
                width="100%"
                height="600px"
            >
                <p>PDF cannot be displayed. Please use following URL</p>
                {/* <p>{pdfUrl && (<a href={pdfUrl}>Download PDF</a>)}</p> */}
            </object>
        </div>
    );
};

export default PdfViewer;
